import { render, staticRenderFns } from "./index-副本.vue?vue&type=template&id=34c86af5&scoped=true"
import script from "./index-副本.vue?vue&type=script&lang=js"
export * from "./index-副本.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c86af5",
  null
  
)

export default component.exports